import React from 'react';

const KanbanCardSkeleton = ({ count = 3 }) => {
  return (
    <div className="space-y-3">
      {Array.from({ length: count })?.map((_, index) => (
        <div
          key={`skeleton-${index}`}
          className="bg-surface border border-border rounded-lg p-4 animate-shimmer"
          style={{ animationDelay: `${index * 0.1}s` }}
        >
          {/* Header with badge */}
          <div className="flex items-start justify-between mb-3">
            <div className="h-5 w-20 bg-muted rounded animate-shimmer" />
            <div className="h-6 w-16 bg-muted rounded-full animate-shimmer" />
          </div>

          {/* Title */}
          <div className="h-4 w-3/4 bg-muted rounded mb-2 animate-shimmer" />

          {/* Description lines */}
          <div className="space-y-2 mb-3">
            <div className="h-3 w-full bg-muted/70 rounded animate-shimmer" />
            <div className="h-3 w-5/6 bg-muted/70 rounded animate-shimmer" />
          </div>

          {/* Footer with icons */}
          <div className="flex items-center justify-between pt-3 border-t border-border">
            <div className="flex items-center gap-2">
              <div className="h-6 w-6 bg-muted rounded-full animate-shimmer" />
              <div className="h-3 w-16 bg-muted rounded animate-shimmer" />
            </div>
            <div className="h-6 w-12 bg-muted rounded animate-shimmer" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default KanbanCardSkeleton;